<div class="main pt-3">
  <div class="container " style="max-width: 1400px">
    <div class="card pt-4" [class.shadow-none]="false">
      <div class="card-header align-items-start">
        <div class="d-flex flex-column">
          <h2 class="modal-title mb-1">{{ 'companyProfile.addEvent.title' | translate }}</h2>
          <p class="text-muted small mb-0">{{ 'common.requiredFieldsHint' | translate }}</p>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <h3>{{ 'companyProfile.addEvent.baseInfo' | translate }}</h3>
        </div>

        <div class="row spacing-15">
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="('companyProfile.addEvent.eventName' | translate) + ' *'"
              [type]="'text'"
              [placeholder]="'companyProfile.addEvent.eventNamePlaceholder' | translate"
              [(value)]="event_name"
              [invalid]="isEventNameInvalid"
            />
          </div>
          <div class="col-lg-6 col-12">
            <label class="form-label">{{ 'companyProfile.addEvent.selectEventType' | translate }} *</label>
            <app-selectorini
              [options]="eventTypes"
              [displayKey]="'event_type_name'"
              [placeholder]="'companyProfile.addEvent.selectEventType' | translate"
              [multiple]="false"
              [(value)]="event_type_id"
              [invalid]="isEventTypeInvalid"
            />
          </div>
        </div>

        <div class="row g-4 spacing-30">
          <div class="col-lg-12 col-12">
            <label class="ms-2 f-14 fw-bold spacing-15">{{ 'companyProfile.addEvent.eventDescription' | translate }}</label>
            <app-markdown-editorini
              [value]="event_description"
              (valueChange)="event_description = $event"
            />
          </div>
        </div>
        <div class="row">
          <h3>{{ 'companyProfile.addEvent.dateInfo' | translate }}</h3>
        </div>
        <div class="row g-4 spacing-30">
          <div class="col-lg-4 col-12">
            <app-input-component
              [label]="('companyProfile.addEvent.startDate' | translate) + ' *'"
              [type]="'datetime-local'"
              [placeholder]="'companyProfile.addEvent.startDatePlaceholder' | translate"
              [(value)]="start_date"
              [invalid]="isStartDateInvalid"
            />
          </div>
          <div class="col-lg-4 col-12">
            <app-input-component
              [label]="'companyProfile.addEvent.endDate' | translate"
              [type]="'datetime-local'"
              [placeholder]="'companyProfile.addEvent.endDatePlaceholder' | translate"
              [(value)]="end_date"
            />
          </div>
          <div class="col-lg-4 col-12">
            <app-input-component
              [label]="'companyProfile.addEvent.registrationDeadline' | translate"
              [type]="'datetime-local'"
              [placeholder]="'companyProfile.addEvent.registrationDeadlinePlaceholder' | translate"
              [(value)]="registration_deadline"
            />
          </div>
        </div>
        <div class="row">
          <h3>{{ 'companyProfile.addEvent.addressInfo' | translate }}</h3>
        </div>
        <div class="row g-4 spacing-15">
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="'companyProfile.addEvent.address' | translate"
              [placeholder]="'companyProfile.addEvent.address' | translate"
              [type]="'text'"
              [(value)]="address"
            />
          </div>
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="'companyProfile.addEvent.city' | translate"
              [placeholder]="'companyProfile.addEvent.city' | translate"
              [type]="'text'"
              [(value)]="city"
            />
          </div>
        </div>
        <div class="row g-4 spacing-30">
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="'companyProfile.addEvent.postalCode' | translate"
              [placeholder]="'companyProfile.addEvent.postalCode' | translate"
              [type]="'number'"
              [(value)]="postal_code"
            />
          </div>
          <div class="col-lg-6 col-12">
            <app-input-component
              [label]="'companyProfile.addEvent.country' | translate"
              [placeholder]="'companyProfile.addEvent.country' | translate"
              [type]="'text'"
              [(value)]="country"
            />
          </div>
        </div>

        <div class="row g-4 spacing-30">
          <div class="col-lg-6 col-12">
            <h4>{{ 'companyProfile.addEvent.eventLogo' | translate }}</h4>
            <app-fileorini
              [accept]="'image/*'"
              (filesChanged)="logo = $event[0]"
            />
          </div>

          <div class="col-lg-6 col-12">
            <h4>{{ 'companyProfile.addEvent.headerImage' | translate }}</h4>
            <app-fileorini
              [accept]="'image/*'"
              (filesChanged)="header = $event[0]"
            />
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <app-button
              [variant]="'primary'"
              [label]="saving ? ('common.creating' | translate) : ('companyProfile.addEvent.createEvent' | translate)"
              [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-plus'"
              [disabled]="saving"
              (clicked)="addEvent()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
